export default __webpack_public_path__ + "static/media/logo.6064f4d8.svg";